import { render, staticRenderFns } from "./LivePlayer.vue?vue&type=template&id=1f98045d&"
import script from "./LivePlayer.vue?vue&type=script&lang=js&"
export * from "./LivePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports